import { Inbox } from 'lucide-react';
import { cn } from '@/shared/utils/cn';

type EmptyStateProps = {
  title?: string;
  message: string;
  className?: string;
};

export const EmptyState = ({
  title = 'No Data',
  message,
  className,
}: EmptyStateProps) => {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center py-12 text-center',
        className,
      )}
    >
      <Inbox className="h-12 w-12 text-gray-300 mb-4" />
      <h4 className="text-lg font-medium text-gray-700 mb-1">{title}</h4>
      <p className="text-sm text-gray-500 max-w-sm">{message}</p>
    </div>
  );
};
